<template>
    <div class="card">
        <div class="card-header bg-transparent text-left">
            <div class="row">
                <div class="col-10 text-left">
                    <strong>Vendas de hoje por hora</strong>
                </div>
                <div class="col-2 text-right">
                    <font-awesome-icon icon="sync" @click="updateData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
                </div>
            </div>
        </div>

        <div class="card-body">
            <revenues-count-itens
                v-if="isLoading"
                :options="options"
                :chart-data="chartdata"
            />
            <font-awesome-icon v-else icon="spinner" size="2x" spin  />
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-md-6 text-md-right text-center">
                    <strong>Quantidade total:</strong> {{total}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import revenuesCountItens from '@/components/graphs/revenuesCountItens.vue'
    export default {
        name: 'wdgRevenuesCountItens',
        components:{
          revenuesCountItens
        },
        computed: {
            getToken: function(){
                return this.$store.getters.getToken
            }
        },
        data(){
          return {
                total: 0,
                isLoading: false,
                chartdata: {
                    labels  : [],
                    datasets: []
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {

                        }
                    }
                }
          }
        },
        methods: {
            updateData: function(){
                let url = server + 'graficos/receita/hora'
                this.isLoading = false
                fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        console.log('Response', '=>', responseJSON.response)
                        let data = responseJSON.response
                        let labels = []
                        let dtset   = []
                        this.total = 0

                        this.chartdata.labels = []
                        this.chartdata.datasets = []

                        for (let index = 0; index < data.length; index++) {
                            const element = data[index];
                            labels.push(element.PERIODO)

                            dtset.push(element.QUANTIDADE_ITENS)
                            this.total = parseInt(this.total) + parseInt(element.QUANTIDADE_ITENS)
                        }

                        this.chartdata.labels = labels
                        this.chartdata.datasets.push({
                            label: 'Vendas',
                            backgroundColor: '#007bff',
                            data: dtset
                        })

                        this.options.tooltips.callbacks.title = function(tooltipItems, data){
                            var tooltipItem = tooltipItems[0];

                            return  data.labels[tooltipItem.index] + ' Horas' 
                        }
                        
                        this.isLoading = true
                    })
                    .catch(error => (console.log(error)));
            }
        },
        mounted () {
            this.updateData()
        }

    }
</script>